import {Component, inject, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {NgClass} from '@angular/common';
import {ModalService} from '../../../../services/modal.service';
import {LeadGenService} from '../../../../services/lead-gen.service';

@Component({
  selector: 'app-lead-gen-popup',
  standalone: true,
  imports: [FormsModule, NgClass],
  templateUrl: './lead-gen-popup.component.html',
  styleUrl: './lead-gen-popup.component.scss'
})
export class LeadGenPopupComponent {
  private modalService = inject(ModalService);
  private leadGenService = inject(LeadGenService);

  protected readonly showModal = this.modalService.showLeadGenModal;
  protected email = '';
  protected showThankYou = signal(false);
  protected showError = signal(false);

  submit(): void {
    if (!this.leadGenService.isValidEmail(this.email)) {
      this.showError.set(true);
      return;
    }
    this.showError.set(false);
    this.leadGenService.submitEmail(this.email.trim());
    this.showThankYou.set(true);
    setTimeout(() => {
      this.showThankYou.set(false);
      this.email = '';
      this.modalService.closeLeadGenModal();
    }, 1500);
  }

  onEmailInput(): void {
    if (this.showError()) {
      this.showError.set(false);
    }
  }

  dismiss(): void {
    this.leadGenService.recordDismissal();
    this.email = '';
    this.showError.set(false);
    this.modalService.closeLeadGenModal();
  }
}
